export const FETCHING_TWC_WARRANTIES_ADMIN = '@@toyota/FETCHING_TWC_WARRANTIES_ADMIN';
export const FETCHED_TWC_WARRANTIES_ADMIN = '@@toyota/FETCHED_TWC_WARRANTIES_ADMIN';
export const FETCHED_TWC_WARRANTIES_ADMIN_FAILED = '@@toyota/FETCHED_TWC_WARRANTIES_ADMIN_FAILED';

export const ADDING_TWC_WARRANTIES_ADMIN = '@@toyota/ADDING_TWC_WARRANTIES_ADMIN';
export const ADDED_TWC_WARRANTIES_ADMIN = '@@toyota/ADDED_TWC_WARRANTIES_ADMIN';
export const ADDED_TWC_WARRANTIES_ADMIN_FAILED = '@@toyota/ADDED_TWC_WARRANTIES_ADMIN_FAILED';

export const FETCHING_TWC_WARRANTIES_ADMIN_JOB = '@@toyota/FETCHING_TWC_WARRANTIES_ADMIN_JOB';
export const FETCHED_TWC_WARRANTIES_ADMIN_JOB = '@@toyota/FETCHED_TWC_WARRANTIES_ADMIN_JOB';
export const FETCHED_TWC_WARRANTIES_ADMIN_JOB_FAILED = '@@toyota/FETCHED_TWC_WARRANTIES_ADMIN_JOB_FAILED';

export const FETCHING_TWC_WARRANTIES_ADMIN_SUBCONTRACT_LIST = '@@toyota/FETCHING_TWC_WARRANTIES_ADMIN_SUBCONTRACT_LIST';
export const FETCHED_TWC_WARRANTIES_ADMIN_SUBCONTRACT_LIST = '@@toyota/FETCHED_TWC_WARRANTIES_ADMIN_SUBCONTRACT_LIST';
export const FETCHED_TWC_WARRANTIES_ADMIN_SUBCONTRACT_LIST_FAILED =
  '@@toyota/FETCHED_TWC_WARRANTIES_ADMIN_SUBCONTRACT_LIST_FAILED';

export const CLEAR_WARRANTY_ADMIN = '@@toyota/CLEAR_WARRANTY_ADMIN';
export const CLEAR_WARRANTIES_ADMIN = '@@toyota/CLEAR_WARRANTIES_ADMIN';
export const CLEAR_SEARCH_PART_WARRANTY_ADMIN = '@@toyota/CLEAR_SEARCH_PART_WARRANTY_ADMIN';
export const CLEAR_WARRANTY_ADMIN_CHASSIS = '@@toyota/CLEAR_WARRANTY_ADMIN_CHASSIS';
export const CLEAR_UPDATE_WARRANTY_ADMIN = '@@toyota/CLEAR_UPDATE_WARRANTY_ADMIN';

export const FETCHING_TWC_WARRANTIES_ADMIN_PART = '@@toyota/FETCHING_TWC_WARRANTIES_ADMIN_PART';
export const FETCHED_TWC_WARRANTIES_ADMIN_PART = '@@toyota/FETCHED_TWC_WARRANTIES_ADMIN_PART';
export const FETCHED_TWC_WARRANTIES_ADMIN_PART_FAILED = '@@toyota/FETCHED_TWC_WARRANTIES_ADMIN_PART_FAILED';

export const FETCHING_TWC_WARRANTY_ADMIN_ATTACHMENTS = '@@toyota/FETCHING_TWC_WARRANTY_ADMIN_ATTACHMENTS ';
export const FETCHED_TWC_WARRANTY_ADMIN_ATTACHMENTS = '@@toyota/FETCHED_TWC_WARRANTY_ADMIN_ATTACHMENTS ';
export const FETCHED_TWC_WARRANTY_ADMIN_ATTACHMENTS_FAILED = '@@toyota/FETCHED_TWC_WARRANTY_ADMIN_ATTACHMENTS_FAILED';


export const FETCHING_TWC_WARRANTIES_ADMIN_BY_ID = '@@toyota/FETCHING_TWC_WARRANTIES_ADMIN_BY_ID';
export const FETCHED_TWC_WARRANTIES_ADMIN_BY_ID = '@@toyota/FETCHED_TWC_WARRANTIES_ADMIN_BY_ID';
export const FETCHED_TWC_WARRANTIES_ADMIN_BY_ID_FAILED = '@@toyota/FETCHED_TWC_WARRANTIES_ADMIN_BY_ID_FAILED';

export const ADDING_TWC_WARRANTIES_ADMIN_ATTACHMENTS = '@@toyota/ADDING_TWC_WARRANTIES_ADMIN_ATTACHMENTS';
export const ADDED_TWC_WARRANTIES_ADMIN_ATTACHMENTS = '@@toyota/ADDED_TWC_WARRANTIES_ADMIN_ATTACHMENTS';
export const ADDED_TWC_WARRANTIES_ADMIN_ATTACHMENTS_FAILED = '@@toyota/ADDED_TWC_WARRANTIES_ADMIN_ATTACHMENTS_FAILED';

export const UPDATING_TWC_WARRANTIES_ADMIN = '@@toyota/UPDATING_TWC_WARRANTIES_ADMIN';
export const UPDATED_TWC_WARRANTIES_ADMIN = '@@toyota/UPDATED_TWC_WARRANTIES_ADMIN';
export const UPDATED_TWC_WARRANTIES_ADMIN_FAILED = '@@toyota/UPDATED_TWC_WARRANTIES_ADMIN_FAILED';

export const FETCHING_TWC_WARRANTY_ADMIN_CHASSIS = '@@toyota/FETCHING_TWC_WARRANTY_ADMIN_CHASSIS';
export const FETCHED_TWC_WARRANTY_ADMIN_CHASSIS = '@@toyota/FETCHED_TWC_WARRANTY_ADMIN_CHASSIS';
export const FETCHED_TWC_WARRANTY_ADMIN_CHASSIS_FAILED = '@@toyota/FETCHED_TWC_WARRANTY_ADMIN_CHASSIS_FAILED';

export const FETCHING_WARRANTY_ADMIN_STATUS = '@@toyota/FETCHING_WARRANTY_ADMIN_STATUS';
export const FETCHED_WARRANTY_ADMIN_STATUS = '@@toyota/FETCHED_WARRANTY_ADMIN_STATUS';
export const FETCHED_WARRANTY_ADMIN_STATUS_FAILED = '@@toyota/FETCHED_WARRANTY_ADMIN_STATUS_FAILED';

export const FETCHING_CONDITION_LIST_WARRANTY_ADMIN = '@@toyota/FETCHING_CONDITION_LIST_WARRANTY_ADMIN';
export const FETCHED_CONDITION_LIST_WARRANTY_ADMIN = '@@toyota/FETCHED_CONDITION_LIST_WARRANTY_ADMIN';
export const FETCHED_CONDITION_LIST_WARRANTY_ADMIN_FAILED = '@@toyota/FETCHED_CONDITION_LIST_WARRANTY_ADMIN_FAILED';

export const FETCHING_CAUSE_LIST_WARRANTY_ADMIN = '@@toyota/FETCHING_CAUSE_LIST_WARRANTY_ADMIN';
export const FETCHED_CAUSE_LIST_WARRANTY_ADMIN = '@@toyota/FETCHED_CAUSE_LIST_WARRANTY_ADMIN';
export const FETCHED_CAUSE_LIST_WARRANTY_ADMIN_FAILED = '@@toyota/FETCHED_CAUSE_LIST_WARRANTY_ADMIN_FAILED';

export const FETCHING_REPAIR_LIST_WARRANTY_ADMIN = '@@toyota/FETCHING_REPAIR_LIST_WARRANTY_ADMIN';
export const FETCHED_REPAIR_LIST_WARRANTY_ADMIN = '@@toyota/FETCHED_REPAIR_LIST_WARRANTY_ADMIN';
export const FETCHED_REPAIR_LIST_WARRANTY_ADMIN_FAILED = '@@toyota/FETCHED_REPAIR_LIST_WARRANTY_ADMIN_FAILED';

export const ADD_CONDITION_WARRANTY_ADMIN = '@@toyota/ADD_CONDITION_WARRANTY_ADMIN';
export const ADD_CAUSE_WARRANTY_ADMIN = '@@toyota/ADD_CAUSE_WARRANTY_ADMIN';
export const ADD_REPAIR_WARRANTY_ADMIN = '@@toyota/ADD_REPAIR_WARRANTY_ADMIN';

export const PROCESSING_WARRANTY_EXCEL_LIST = '@@toyota/PROCESSING_WARRANTY_EXCEL_LIST';
export const PROCESSED_WARRANTY_EXCEL_LIST = '@@toyota/PROCESSED_WARRANTY_EXCEL_LIST';
export const PROCESSED_WARRANTY_EXCEL_LIST_FAILED = '@@toyota/PROCESSED_WARRANTY_EXCEL_LIST_FAILED';
export const ADDING_WARRANTY_EXCEL_LIST = '@@toyota/ADDING_WARRANTY_EXCEL_LIST';
export const ADDED_WARRANTY_EXCEL_LIST = '@@toyota/ADDED_WARRANTY_EXCEL_LIST';
export const ADDED_WARRANTY_EXCEL_LIST_FAILED =
  '@@toyota/ADDED_WARRANTY_EXCEL_LIST_FAILED';

export const CHECKING_TWC_WARRANTIES_CHASSIS_KM = '@@toyota/CHECKING_TWC_WARRANTIES_CHASSIS_KM';
export const CHECKED_TWC_WARRANTIES_CHASSIS_KM = '@@toyota/CHECKED_TWC_WARRANTIES_CHASSIS_KM';
export const CHECKED_TWC_WARRANTIES_CHASSIS_KM_FAILED =
  '@@toyota/CHECKED_TWC_WARRANTIES_CHASSIS_KM_FAILED';

export const CLEAR_WARRANTY_EXCEL_LIST = '@@toyota/CLEAR_WARRANTY_EXCEL_LIST';
